import {Formik, Form, FormikHelpers} from 'formik'
import * as Yup from 'yup'
import toast from 'react-hot-toast'
import {handleApiError} from '../../../helpers/errorHandler'
import FormikControl from '../../../components/formikControl/FormikControl'
import {addStudentToTrip} from './api'
import {useQuery} from 'react-query'
import {fetchStudentList} from '../student/api'
import {Student} from '../student/type'
import {RunnerBall} from '../../../components/FormLoader'
import {StudentTripAPIData} from '../../ts/trip'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'

const formInitialValues: {student_id: string} = {
  student_id: '',
}

const valdiationSchema: Yup.Schema<{student_id: string}> = Yup.object({
  student_id: Yup.string().required('Student is required'),
})

function AddStudentToTrip({
  onAfterSubmit,
  initialValues,
}: {
  onAfterSubmit: () => void
  initialValues?: {existingStudentsInTrip: StudentTripAPIData[]; trip_id: string | number}
}) {
  const {data, isFetching} = useQuery({
    queryKey: 'studentList',
    queryFn: () => fetchStudentList({studentClass: '', division: ''}),
    initialData: [],
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  })

  const submitHandler = async (
    values: {student_id: string},
    {setSubmitting}: FormikHelpers<any>
  ) => {
    const toastId = toast.loading('Submitting')

    try {
      await addStudentToTrip({student_id: values.student_id, trip_id: initialValues?.trip_id})
      toast.success('Success', {id: toastId})
      onAfterSubmit()
    } catch (err: any) {
      handleApiError(err, toastId)
    } finally {
      setSubmitting(false)
    }
  }

  if (isFetching) {
    return <RunnerBall />
  }
  const formValues = formInitialValues

  const existingStudentIds = new Set(
    initialValues?.existingStudentsInTrip.map((student) => student.student_id)
  )

  const nonExistingStudentsInTrip = data.data.filter(
    (student: Student) => !existingStudentIds.has(student.student_id)
  )

  return (
    <div className="px-5 py-3">
      <Formik<{student_id: string}>
        initialValues={formValues}
        validationSchema={valdiationSchema}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, values, dirty, isValid}) => (
          <Form>
            <FormikControl
              options={nonExistingStudentsInTrip}
              optionLabel="student_name"
              getOptionLabel={(option: any) => option.student_name + ' - ' + option.regID}
              optionValue="student_id"
              control="select-advanced"
              className="mb-0"
              value={
                data.data.find(
                  (student: Student) => student.student_id === Number(values.student_id)
                ) || null
              }
              required
              placeholder="Student"
              label="Student"
              name="student_id"
            />
            <div className="text-center pt-10">
              <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

              <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default AddStudentToTrip
